App.filter('checkIdentifier', function () {
    return function (identifier) {
        identifier = identifier || '';
        
        return correct(identifier);
    };

    function correct(identifier) {
    	var reg = /^[0-9]{11}$/;    
		if (reg.test(identifier)) {      
			var ssn = identifier.split("");
			var weights = [1,3,7,9], sum = 0, control = 0;

			for (var i = 0; i < 10; i++) {
				sum += ssn[i] * weights[i%4];
			}

			sum = sum % 10;
			if (sum != 0) {
				control = 10 - sum;
			}      

			if (control == ssn[10]) {
				if (identifier !== '12345678910') {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}     
		}
		else {    
			return false;      
		} 
    }
})